export const BANNER_PADDING_TOP = 236
export const PAGE_MARGIN_TOP = -16
export const LINESHEET_CAROUSEL_LITE_RETAILERS_FLAG =
  'linesheet-carousel-lite-retailers'
export const LINESHEET_CAROUSEL_PRO_RETAILERS_FLAG =
  'linesheet-carousel-pro-retailers'
